import {
  Container,
  HeaderCenter,
  HeaderLeft,
  HeaderRight,
  Wrapper,
  Text,
  Button,
  AvatarEditor,
  InputNameDocument,
  HeaderMiddleSharedGroup
} from "./styles";

import backIcon from "../../assets/icon-back.svg";
import undoIcon from "../../assets/icon-undo.svg";
import redoIcon from "../../assets/icon-redo.svg";
import commentsIcon from "../../assets/icon-comments.svg";
import saveIcon from "../../assets/icon-save.svg";
import downloadIcon from "../../assets/icon-download.svg";
import DropdownArchive from "./components/DropdownArchive";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHeaderEditor } from "../../hooks/headerEditor";
import { useMainHook } from "../../../../hooks/main";
import Konva from "konva";
import { useNavigate, useParams } from "react-router-dom";

import iconPenEdit from "../../assets/pen-edit-icon.svg";

import undoIconTransparent from "../../assets/icon-undo-transparent.svg";
import redoIconTransparent from "../../assets/icon-redo-transparent.svg";
import { LoadingFlex } from "../../../login/pages/Login/styles";
import PuffLoader from "react-spinners/PuffLoader";
import { useSelection } from "../../hooks/selection";
import { useTextsEdition } from "../../hooks/textsEdition";
import LetterAvatar from "../../../master/components/LetterAvatar";
import DropdownAvatar from "../DropdownAvatar";
import { useSharedDocument } from "../../hooks/sharedDocument";
import MultiplesAvatarLetter from "../../../master/components/MultiplesAvatarLetter";
import AvatarLengthShared from "../../../master/components/AvatarLengthShared";
import { useAuth } from "../../../../hooks/auth";
import DropdownAvatarDash from "../DropdownAvatarDash";
import api from "../../../../services/api";
import { getColors } from "../../utils/getColorAvatar";
import LoadingEditor from "../LoadingEditor";

interface UsersSharedProps {
  id?: string;
  name?: string;
  email?: string;
  avatar_url?: string;
  permissions?: string;
  is_anonymous?: boolean;
  color?: string;
}

export default function Header() {
  const { generatePDF } = useHeaderEditor();
  const [isOpen, setIsOpen] = useState(false);
  const {
    documentName,
    history,
    srcAvatar,
    currentTemplateInfo,
    myProfileId,
    goToDownload
  } = useMainHook();
  const refInputNameProject = useRef<HTMLInputElement>(null);
  const [showPen, setShowPen] = useState(false);

  const {
    handleSaveTemplate,
    handleGoHomePage,
    handleUndo,
    handleRedo,
    handleCreateNewProject,
    loading,
    setLoading
  } = useHeaderEditor();

  const {
    selectedObject,
    setSelectedObject,
    selectedObjects,
    setSelectedObjects
  } = useSelection();

  const { isEditing } = useTextsEdition();

  const { handleOpenModalShared, handleOpenModalSharedInfo } =
    useSharedDocument();

  const handleMouseEnterSaveTemplate = useCallback(() => {
    setSelectedObject(null);
    setSelectedObjects([]);
  }, [selectedObject, selectedObjects]);

  const { data, permissionType } = useAuth();

  const { templateid } = useParams();

  const [letters, setLetters] = useState("LUCAS JUSTE");
  const [color, setColor] = useState("");
  const [isOwnerDocument, setIsOwnerDocument] = useState(false);
  const [isOpenAvatarConfig, setIsOpenAvatarConfig] = useState(false);

  const generateColor = useCallback(() => {
    setColor(getColors());
  }, []);

  useEffect(() => {
    setLetters(`${data.people.first_name} ${data.people.last_name}`);
    generateColor();
  }, []);

  //temporary
  const { refreshUsersShared } = useSharedDocument();
  const [sharedUsers, setSharedUsers] = useState<UsersSharedProps[]>([]);

  useEffect(() => {
    const autoLoadSharedUsers = async () => {
      try {
        const responseTemplatesUsers = await api.get(
          `user-share-template/all-shared-template-users/${templateid}`
        );

        const generateColorsInData = responseTemplatesUsers.data.users.map(
          (user: UsersSharedProps) => {
            return {
              ...user,
              color: getColors()
            };
          }
        );

        setSharedUsers(generateColorsInData);
      } catch (err) {
        console.log(err, "ERROR when fetch users shared template");
      }
    };

    setTimeout(() => {
      autoLoadSharedUsers();
    }, 1000);
  }, [refreshUsersShared]);

  useEffect(() => {
    setSharedUsers(state => {
      state.map(user => {
        return {
          ...user,
          color: getColors()
        };
      });

      return state;
    });
  }, [refreshUsersShared]);

  useEffect(() => {
    if (myProfileId) {
      const getOwnerId = sharedUsers.find(user => user.permissions === "Owner");

      if (getOwnerId?.id === myProfileId) {
        setIsOwnerDocument(true);
      } else {
        setIsOwnerDocument(false);
      }
    }
  }, [sharedUsers]);

  // this useEffect colects the name of the document to apply on the top
  useEffect(() => {
    (async () => {
      try {
        const userTemplate = await api.get(`user-templates/${templateid}`);
        const { title } = userTemplate.data;

        documentName.current = title;
      } catch (error) {
        console.log("error on getting title of template");
      }
    })();
  }, [""]);

  return (
    <Container>
      <HeaderLeft>
        <Wrapper>
          <button
            className="btn-hover"
            onClick={() => {
              handleGoHomePage();
            }}
          >
            <img className="icon-back" src={backIcon} alt="Ícone de voltar" />
            <Text>Início</Text>
          </button>
        </Wrapper>

        <Wrapper>
          <button onClick={() => setIsOpen(!isOpen)} className="btn-click">
            <DropdownArchive isOpen={isOpen} setIsOpen={setIsOpen} />
          </button>
        </Wrapper>

        <Wrapper>
          <button
            className="btn-click"
            onClick={() => {
              if (isEditing === "open") return;
              handleUndo();
            }}
          >
            <div className="icon-undo">
              <img
                className="redoUndo"
                src={
                  history.currentStep === 0
                    ? undoIconTransparent
                    : isEditing === "open"
                    ? undoIconTransparent
                    : undoIcon
                }
                alt="Ícone de voltar"
              />
            </div>
          </button>
          <button
            className="btn-click"
            onClick={() => {
              if (history.currentStep >= history.step.length - 1) return;
              if (isEditing === "open") return;
              handleRedo();
            }}
          >
            <div className="icon-redo">
              <img
                className="redoRedo"
                src={
                  history.currentStep >= history.step.length - 1
                    ? redoIconTransparent
                    : isEditing === "open"
                    ? redoIconTransparent
                    : redoIcon
                }
                alt="Ícone de avançar"
              />
            </div>
          </button>
        </Wrapper>
      </HeaderLeft>

      <HeaderCenter>
        {/* <input type="text" /> */}
        {!!documentName.current ? (
          <InputNameDocument
            showPen={showPen}
            ref={refInputNameProject}
            type="text"
            placeholder="Novo documento"
            readOnly={permissionType === "editor" ? true : false}
            onMouseEnter={e => {
              setShowPen(!showPen);
            }}
            onMouseLeave={e => {
              setShowPen(!showPen);
            }}
            //value={documentName.current ? documentName.current : "Novo documento"}
            defaultValue={documentName.current}
            onChange={(onChangeEvent: React.ChangeEvent<HTMLInputElement>) => {
              documentName.current = onChangeEvent.target.value;
            }}
            onBlur={() => handleSaveTemplate(true)}
          />
        ) : (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <LoadingEditor height={30} width={30} color={"#FFF"} />
          </div>
        )}
        {/* {!showPen ? (
          <button
            style={{ cursor: "pointer", background: "transparent" }}
            onClick={() => setShowPen(true)}
          >
            <img style={{ marginLeft: !showPen && "1rem" }} src={iconPenEdit} />
          </button>
        ) : null} */}
        {/* <Text margin="0 auto"></Text> */}
      </HeaderCenter>

      {sharedUsers?.length === 1 ? (
        <div></div>
      ) : sharedUsers?.length === 2 ? (
        <HeaderMiddleSharedGroup onClick={handleOpenModalSharedInfo}>
          <MultiplesAvatarLetter
            src={sharedUsers[0]?.avatar_url}
            text={sharedUsers[0]?.name}
            color={getColors(true)}
            isAnnonymous={sharedUsers[0]?.is_anonymous}
            isHeader
          />
          <MultiplesAvatarLetter
            className="adjust-avatar-multiples2rd"
            src={sharedUsers[1]?.avatar_url}
            text={sharedUsers[1]?.name}
            color={sharedUsers[1]?.color}
            isAnnonymous={sharedUsers[1]?.is_anonymous}
            isHeader
          />
        </HeaderMiddleSharedGroup>
      ) : sharedUsers?.length === 3 ? (
        <HeaderMiddleSharedGroup onClick={handleOpenModalSharedInfo}>
          <MultiplesAvatarLetter
            src={sharedUsers[0]?.avatar_url}
            text={sharedUsers[0]?.name}
            color={getColors(true)}
            isAnnonymous={sharedUsers[0]?.is_anonymous}
            isHeader
          />
          <MultiplesAvatarLetter
            className="adjust-avatar-multiples2rd"
            src={sharedUsers[1]?.avatar_url}
            text={sharedUsers[1]?.name}
            color={sharedUsers[1]?.color}
            isAnnonymous={sharedUsers[1]?.is_anonymous}
            isHeader
          />
          <MultiplesAvatarLetter
            className="adjust-avatar-multiples3rd"
            src={sharedUsers[2]?.avatar_url}
            text={sharedUsers[2]?.name}
            color={sharedUsers[2]?.color}
            isAnnonymous={sharedUsers[2]?.is_anonymous}
            isHeader
          />
        </HeaderMiddleSharedGroup>
      ) : (
        sharedUsers?.length >= 4 && (
          <HeaderMiddleSharedGroup onClick={handleOpenModalSharedInfo}>
            <MultiplesAvatarLetter
              src={sharedUsers[0]?.avatar_url}
              text={sharedUsers[0]?.name}
              color={getColors(true)}
              isAnnonymous={sharedUsers[0]?.is_anonymous}
              isHeader
            />
            <MultiplesAvatarLetter
              className="adjust-avatar-multiples2rd"
              src={sharedUsers[1]?.avatar_url}
              text={sharedUsers[1]?.name}
              color={sharedUsers[1]?.color}
              isAnnonymous={sharedUsers[1]?.is_anonymous}
              isHeader
            />
            <MultiplesAvatarLetter
              className="adjust-avatar-multiples3rd"
              src={sharedUsers[2]?.avatar_url}
              text={sharedUsers[2]?.name}
              color={sharedUsers[2]?.color}
              isAnnonymous={sharedUsers[2]?.is_anonymous}
              isHeader
            />
            <AvatarLengthShared
              length={sharedUsers?.length}
              className="avatar-length"
              src=""
            />
          </HeaderMiddleSharedGroup>
        )
      )}

      <HeaderRight>
        {/* <button className="btn-click">
          <img
            className="redoUndo"
            src={commentsIcon}
            alt="Ícone de comentários22"
          />
        </button> */}
        <button
          className="btn-click"
          onMouseEnter={handleMouseEnterSaveTemplate}
          onClick={() => handleSaveTemplate(false)}
        >
          {loading ? (
            <LoadingFlex>
              <PuffLoader color="#ffff" size="28" />
            </LoadingFlex>
          ) : (
            <img className="save" src={saveIcon} alt="Ícone de salvar" />
          )}
        </button>
        <button
          style={
            permissionType === "editor"
              ? { opacity: 0.2, cursor: "not-allowed" }
              : {}
          }
          className="btn-click"
          onClick={() => {
            if (permissionType === "editor") return;
            setSelectedObject(null);
            generatePDF();
          }}
        >
          {!goToDownload ? (
            <img
              className="download"
              src={downloadIcon}
              alt="Ícone de download"
            />
          ) : (
            <LoadingFlex>
              <PuffLoader color="#ffff" size="28" />
            </LoadingFlex>
          )}
        </button>

        {isOwnerDocument && permissionType === "normal" ? (
          <Button
            target="_blank"
            onClick={() => {
              setSelectedObject(null);
              handleOpenModalShared(templateid);
            }}
            color="black"
          >
            <a target="_blank"> Compartilhar </a>
          </Button>
        ) : (
          <Button
            target="_blank"
            className="disable-hover"
            disabled={true}
            style={
              permissionType === "editor"
                ? { opacity: 0.2, cursor: "not-allowed" }
                : {}
            }
            // onClick={() => handleOpenModalShared(templateid)}
            color="black"
          >
            <a target="_blank"> Compartilhar </a>
          </Button>
        )}

        <Button
          style={
            permissionType === "editor"
              ? { opacity: 0.2, cursor: "not-allowed" }
              : {}
          }
          target="_blank"
          onClick={() => {
            if (permissionType === "editor") return;
            handleCreateNewProject();
          }}
          color="black"
        >
          <a target="_blank"> Novo projeto </a>
        </Button>

        {/*disable dropdown by request of tech team at organization bits*/}

        <DropdownAvatarDash
          isOpen={isOpenAvatarConfig}
          setIsOpen={setIsOpenAvatarConfig}
          color={color}
          isEditor={true}
        >
          <MultiplesAvatarLetter
            className="avatar-dashboard"
            src={String(srcAvatar)}
            isEditor={true}
            text={letters}
            setText={setLetters}
            color={getColors(true)}
          />
        </DropdownAvatarDash>
      </HeaderRight>
    </Container>
  );
}
